export { default } from './biography';
